// extracted by mini-css-extract-plugin
export var aiStarSpin = "_qs-1";
export var spinner = "_qs-0";